import { createIcon } from '@mote/ui/components/icon'
import { defaultProps } from '../defaultProps'

export const FacebookIcon = createIcon({
  d: 'M24.5456 18.5787H22.3207V17.1116C22.3207 16.8644 22.3906 16.6816 22.5303 16.5634C22.6378 16.4774 22.7722 16.4344 22.9334 16.4344H24.5133V14.0161L22.3369 14C21.5952 14 20.9826 14.172 20.4989 14.5159C20.1013 14.7954 19.8057 15.1823 19.6122 15.6767C19.4617 16.0744 19.3865 16.5043 19.3865 16.9665V18.5787H18V21.0615H19.3865V28.1069H22.3207V21.0615H24.2876L24.5456 18.5787Z',
  displayName: 'FacebookIcon',
  viewBox: '0 0 42 42',
  defaultProps: defaultProps
})
